import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormArray,FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { distinctUntilChanged, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { AccountsReceivableLedgerTypeEnum,ARLTypeEnumNames,availableBookingPositionTypeEnums,isBookingPositionTypeEnum } from '../../../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import { LengthPipe } from '../../../../../helper/length.pipe';
import { arlBaseCostAllowanceFormGroup,getARLBaseCostAllowanceForm } from '../../arl-form-data.service';
import { ArlChargeDialogBase } from '../arl-charge-dialog/ArlChargeDialogBase';
import { firstValueFrom, merge } from 'rxjs';

export type ArlChargeByTypeDialogComponentDialogReturnData = undefined;
export interface ArlChargeByTypeDialogComponentDialogData {
    arlChargeFormArray: FormArray<arlBaseCostAllowanceFormGroup>;
}
@Component({
    selector: 'app-arl-charge-by-type-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FontAwesomeModule,
        MatLegacyFormFieldModule,
        FormsModule,
        MatLegacyInputModule,
        MatLegacyListModule,
        MatLegacyButtonModule,
        MatLegacyTooltipModule,
        ReactiveFormsModule,
        MatLegacyDialogModule,
        AppButtonModule,
        MatLegacySelectModule,
        LengthPipe,
    ],
    templateUrl: './arl-charge-by-type-dialog.component.html',
    styleUrls: ['./arl-charge-by-type-dialog.component.scss'],
})
export class ArlChargeByTypeDialogComponent extends ArlChargeDialogBase {
    protected filterAllowanceCharges(form: arlBaseCostAllowanceFormGroup): boolean {
        return !!form.value.arlType && (form.value.percent || 0) >= 0;
    }
    constructor(@Inject(MAT_DIALOG_DATA) dialogData: ArlChargeByTypeDialogComponentDialogData) {
        super(dialogData.arlChargeFormArray);
    }
    protected typeOptions = availableBookingPositionTypeEnums.filter(isBookingPositionTypeEnum).map((q) => ({ value: q, label: ARLTypeEnumNames.get(q) }));
    protected filteredTypeOptions$ = this.shownArlAllowanceFormArray$.pipe(
        switchMap(form => merge(...form.map(f => f.valueChanges)).pipe(
            startWith(null),
            map(() => {
                const types = form.map((s) => s.getRawValue().arlType);
                return this.typeOptions.filter((type) => types.every((t) => t !== type.value));
            }),
        )),
        distinctUntilChanged((a, b) => a.length === b.length && JSON.stringify(a) === JSON.stringify(b)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    async addRandom() {
        const options = await firstValueFrom(this.filteredTypeOptions$)
        if (options.length) {
            this.addByType(options[0].value);
        }
    }
    addByType(arlType: AccountsReceivableLedgerTypeEnum) {
        this.add(
            getARLBaseCostAllowanceForm(
                {
                    title: null,
                    percent: null,
                    arlType,
                },
                'surcharge',
                true,
            ),
        );
    }

    protected readonly ARLTypeEnumNames = ARLTypeEnumNames;
}
